export class LastCallError extends Error {
  constructor({errorType, details, message}) {
    super()
    this._details = details
    this._errorType = errorType
    this._message = message || `${errorType} - ${details}`
  }

  toJSON() {
    return {
      errorType: this._errorType,
      details: this._details
    }
  }
}
